import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "truncate w-full leading-5 text-xs"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmWord',
  props: {
    name: {
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ["click", "update:checked", "click-full"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    function handleClick() {
      if (props.disabled) {
        emits('click-full');
        return;
      }
      emits('click');
    }
    const UpdateModelValue = val => {
      emits('update:checked', val);
    };
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_i_home_full = _resolveComponent("i-home-full");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["confirm-word", {
          checked: __props.checked,
          active: __props.active,
          disabled: __props.disabled
        }]),
        onClick: handleClick
      }, [_createVNode(_component_el_checkbox, {
        "model-value": __props.checked,
        "onUpdate:modelValue": UpdateModelValue
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(__props.name), 1)]),
        _: 1
      }, 8, ["model-value"]), _createElementVNode("div", {
        class: "icon-box",
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => emits('click-full'), ["stop"]))
      }, [_createVNode(_component_i_home_full)])], 2);
    };
  }
});